import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { store } from '../../services/service';
import { useStoreSurvey } from '../../store/SurveyStore';
import { MODIFIER_LIVRAISON, SURVEY_PAR_TYPE } from '../../Utils/constant';

export const UpdateNumeroFtth = ({ item }) => {

    const survey = useStoreSurvey()
    const [error, setError] = useState(null)
    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const submit = (data) => {
        setIsSubmit(true)
        store(`${MODIFIER_LIVRAISON}?numeroFtth=${data.numeroFtth}&numeroTicket=${item?.eligibilite?.numeroTicket}&numeroSerie=""`, "application/json", {}).then((res) => {
            setIsSubmit(false);
            reset();
            survey.getData(`${SURVEY_PAR_TYPE}?page=0&param=&size=8&periode=&mois=&annee=&dateDebut=&dateFin=&status=EN_ATTENTE&resultat=&typeRdv=SURVEY`)
            document.getElementById('edit').close()
            toast.success('Mis à jour effectuée')
        }).catch((err) => {
            setIsSubmit(false)
            setError(err?.response?.data?.donnee)
        })
    }

    useEffect(() => {
        if (item) {
            reset();
        }
    }, [item, reset]);

    return (
        <div>
            <form onSubmit={handleSubmit(submit)} className='px-2'>
                <p className='text-sm text-red-600'>{error}</p>
                <div className='my-4 space-y-4'>
                    <div className='my-2'>
                        <label htmlFor="" className='text-sm font-medium'>Numero Ftth</label>
                        <input {...register('numeroFtth', { required: true })} defaultValue={item?.abonnement?.numeroFtth} type="text" placeholder="" className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        />
                        {errors.numeroFtth && <span className="text-sm text-rose-600">Ce champs est obligatoire</span>}
                    </div>


                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        onClick={() => {
                            setError(null)
                        }}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                        {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>
            </form>
        </div>
    )
}
